import React, { useState, useEffect } from 'react';
import Layout from '../common/layoutred';
import Button from '../../assets/images/backgrounds/submit_button.png';
import './style.scss';
import { connect } from 'react-redux';
import { setInitialLanguage } from '../../store/trackinguser/actions';
import CuLayout from '../../utils/gameLayout';
import Gamestart from '../gamestart';


const InitialLanguageSelection = ({
    languages,
    setInitialLanguage,
}) => {
    const [language, setLanguage] = useState("en");
    const [isNextBtnClicked, setIsNextBtnClicked] = useState(false);

    const handleLanguageChange = ($event) => {
        setLanguage($event.target.value);
    }

    const nextPage = () => {
        setInitialLanguage(language);
        setIsNextBtnClicked(true);
    }

    return (
        <>
           { !isNextBtnClicked ? (
                <Layout>
                <div className="language__container">
                    <form>
                    <div className="form__control">
                        <select name="lang" onChange={handleLanguageChange}>
                        {languages
                            ? languages.map((lan) => (
                                <option key={lan.value} value={lan.value}>
                                {lan.language}
                                </option>
                            ))
                            : null}
                        </select>
                    </div>
        
                    <div className="form__control next_button" onClick={nextPage} >
                        <img src={Button} alt="next_image" />
                        <div type="submit" className="button__text">
                        Next
                        </div>
                    </div>
                    </form>
                </div>
                </Layout>
            ) : (
                <CuLayout>
                    <Gamestart />
                </CuLayout>
            )}
        </>
  
    );
}

const mapStateToProps = (state) => {
    return {
    };
  };

  const mapDisPatchToProps = (dispatch) => {
    return {
        setInitialLanguage: (lang) => dispatch(setInitialLanguage(lang)),
    };
  };

  export default connect(mapStateToProps, mapDisPatchToProps)(InitialLanguageSelection);